import React, {useEffect, useState} from "react";
import "../styles.css";
import RKQuestionOptionNew from "./RKQuestionOptionNew";
import classes from "../questions.module.css";
import {DragDropContext, Droppable} from "react-beautiful-dnd";
import YuJaButton from "../../components/standardization/YuJaButton";
import {addOptionToQuestion, addRankToQuestion} from "../../utils/questionUtils";
import {findFirstOverflowParent, notifyInfo} from "../../utils/helpers";
import {ReactComponent as PlusIcon} from "../../images/plus.svg";
import { useTranslation } from "react-i18next";


export default function RKQuestionNew({
                                          setQuestions,
                                          questions,
                                          selectedQuestion,
                                          questionBuilder = false,
                                          disabled = false,
}) {
    const { t } = useTranslation();
    const {serialNo, optionsMap} = selectedQuestion;
    const [warningShowed, setWarningShowed] = useState(false);
    const [showButton, setShowButton] = useState(true);

    const initializeCollapse = () => {
        const res = {};

        optionsMap.forEach((option, index) => {
            res[index] = true;
        });
        return res;
    }

    const [collapseStatusObj, setCollapseStatusObj] = useState(() => initializeCollapse());

    useEffect(() => {
        setCollapseStatusObj(initializeCollapse);
    }, [serialNo]);

    useEffect(() => {
        if (optionsMap.length > Object.keys(collapseStatusObj).length) {
            let copy = {};
            optionsMap.forEach((option, index) => {
                copy[index] = collapseStatusObj.hasOwnProperty(index) ? collapseStatusObj[index] : true;
            })
            setCollapseStatusObj(copy);
        }
    }, [optionsMap]);


    const handleDragStart = () => {
        setShowButton(false);
    };

    const handleDragEnd = () => {
        setShowButton(true);
    };


    const handleAnswerOrderChange = (result) => {
        if (!result.destination || result.source.index === result.destination.index) {
            return;
        }

        let newQuestions = [];
        const sourceKey = result.source.index;
        const destinationKey = result.destination.index;
        questions.forEach((q) => {
            if (q.serialNo !== serialNo) {
                newQuestions.push(q);
            } else {
                const questionCopy = JSON.parse(JSON.stringify(q));
                let newOptionsMap = [...questionCopy.optionsMap];
                const [removed] = newOptionsMap.splice(sourceKey, 1);
                newOptionsMap.splice(destinationKey, 0, removed);

                questionCopy.optionsMap = newOptionsMap;
                newQuestions.push(questionCopy);
            }
        });

        let copy = {};
        let copyValues = [...Object.values(collapseStatusObj)];
        const [removed] = copyValues.splice(sourceKey, 1);
        copyValues.splice(destinationKey, 0, removed);
        copyValues.forEach((option, index) => {
            copy[index] = option;
        });


        setCollapseStatusObj(copy);
        setQuestions(newQuestions);
    };

    return (
        <>
            <DragDropContext
                onDragStart={handleDragStart}
                onDragEnd={(result) => {
                    handleDragEnd();
                    handleAnswerOrderChange(result);
                }}
            >
                <Droppable droppableId="droppable-multiple-choice-question">
                    {(provided, snapshot) => (
                        <div
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                            {...provided.dropHandleProps}
                            className={classes.optionsContainer}
                        >
                            {optionsMap.map((option, index) => {
                                return (
                                    <RKQuestionOptionNew
                                        key={index}
                                        optionData={{choice: index, optionValue: option}}
                                        selectedQuestion={selectedQuestion}
                                        questions={questions}
                                        setQuestions={setQuestions}
                                        index={index}
                                        maxSize={optionsMap.length}
                                        questionBuilder={questionBuilder}
                                        disabled={disabled}
                                        warningShowed={warningShowed}
                                        setWarningShowed={setWarningShowed}
                                        collapsed={!collapseStatusObj.hasOwnProperty(index) || collapseStatusObj[index]}
                                        setCollapsed={(status) => {
                                            let copy = JSON.parse(JSON.stringify(collapseStatusObj));
                                            copy[index] = status;
                                            setCollapseStatusObj(copy);
                                        }}

                                        deleteCollapsed={() => {
                                            let copy = {};
                                            Object.entries(collapseStatusObj).forEach(([key, value]) => {
                                                let realKey = parseInt(key);
                                                if (realKey !== index) {
                                                    if (realKey > index) {
                                                        const newKey = realKey - 1;
                                                        copy[newKey] = value;
                                                    } else {
                                                        copy[realKey] = value;
                                                    }
                                                }
                                            });
                                            setCollapseStatusObj(copy);
                                        }}
                                    />
                                );
                            })}

                            {showButton &&
                                <YuJaButton
                                    title={t("poll.mcssAddOptionText")}
                                    style={{
                                        width: 170,
                                        height: 35,
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        alignSelf: "end"
                                    }}
                                    onClick={(e) => {
                                        const newQuestions = addRankToQuestion(
                                            selectedQuestion,
                                            questions
                                        );
                                        if (newQuestions) {
                                            setQuestions(newQuestions);
                                            let currentTarget = e.currentTarget;
                                            setTimeout(() => {
                                                const parent = findFirstOverflowParent(currentTarget);
                                                parent?.scroll({top: parent.scrollHeight, behavior: "smooth"});
                                            }, 100);
                                        } else if (!warningShowed) {
                                            setWarningShowed(true);
                                            notifyInfo(t("questionBuilder.maxOptionsReachedInfo"));
                                        }
                                    }}
                                >
                                    <PlusIcon
                                        style={{width: 15, height: 15, marginRight: 2}}/> {t("poll.mcssAddOptionText")}
                                </YuJaButton>
                            }
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
        </>

        //
        //     <div style={{width: "100%", display: "flex", justifyContent: "center", paddingBottom: 5}}>
        //         <YuJaButton
        //             title="Add Option"
        //             onClick={() => {
        //                 const newQuestions = addRankToQuestion(
        //                     selectedQuestion,
        //                     questions
        //                 );
        //                 if (newQuestions) {
        //                     setQuestions(newQuestions);
        //                     setTimeout(() => {
        //                         const mcqOptionsContainer = document.getElementById("mcq-options-container");
        //                         mcqOptionsContainer?.scroll({
        //                             top: mcqOptionsContainer.scrollHeight,
        //                             behavior: "smooth"
        //                         });
        //                     }, 10);
        //                 } else if (!warningShowed) {
        //                     setWarningShowed(true);
        //                     notifyInfo(ADD_OPTIONS_INFO);
        //                 }
        //             }}
        //         >
        //             <PlusIcon style={{width: 15, height: 15, marginRight: 2}}/> {MCSS_ADD_OPTION_TEXT}
        //         </YuJaButton>
        //
        // </div>
    );
}